export default __webpack_public_path__ + "static/media/SkankYaLater.828e2952.mp3";